var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "../../box/src";
import { ButtonAndDropdown } from './components/ButtonAndDropdown';
import { SimpleButton } from './components/SimpleButton';
import { TwoButtons } from './components/TwoButtons';
import { getFormattedItems } from './getFormattedItems';
const defaultDropdownScreenReaderTitle = ((_a = window === null || window === void 0 ? void 0 : window.s__) === null || _a === void 0 ? void 0 : _a.call(window, 'dropdown')) || 'dropdown';
const Actions = ({ dropdownScreenReaderTitle, isDisplayInsideTable, items, }) => {
    const numItems = items.length;
    if (numItems === 0) {
        return null;
    }
    if (numItems === 1) {
        const buttonItems = getFormattedItems({ items, type: 'button' });
        return (_jsx(SimpleButton, { isDisplayInsideTable: isDisplayInsideTable, item: buttonItems[0] }));
    }
    if (numItems === 2 && !isDisplayInsideTable) {
        const buttonItems = getFormattedItems({ items, type: 'button' });
        return (_jsx(TwoButtons, { primaryButtonContent: buttonItems[0], secondaryButtonContent: buttonItems[1] }));
    }
    const itemsWithoutFirst = items.slice(1);
    const firstItem = items[0];
    const dropdownItems = getFormattedItems({
        items: itemsWithoutFirst,
        type: 'dropdown',
    });
    const firstButtonItem = getFormattedItems({
        items: [firstItem],
        type: 'button',
    });
    const allItemsFormatted = [...firstButtonItem, ...dropdownItems];
    return (_jsx(ButtonAndDropdown, { dropdownScreenReaderTitle: dropdownScreenReaderTitle, isDisplayInsideTable: isDisplayInsideTable, items: allItemsFormatted }));
};
export const MultipleActions = ({ dropdownScreenReaderTitle = defaultDropdownScreenReaderTitle, isDisplayInsideTable = false, items, wrapperProps, }) => (_jsx(Box, Object.assign({}, wrapperProps, { children: _jsx(Actions, { dropdownScreenReaderTitle: dropdownScreenReaderTitle, isDisplayInsideTable: isDisplayInsideTable, items: items }) })));
//# sourceMappingURL=MultipleActions.js.map